import { ActionTypes } from '../actions/ConflictCourtActions';
// import Helpers         from 'app/utils/helpers/Helpers';

var initial_state = {};

var callables = {

	[ActionTypes.update_conflictcourt](state, action) {
		return Object.assign({}, state, action.conflict_court);
	}
};

export default function(state = initial_state, action) {

	if (callables.hasOwnProperty(action.type)) {
		return callables[action.type](state, action);
	}

	return state;
};